var _path, _g, _g2, _g3, _g4, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _g5, _g6, _g7, _g8, _g9, _g10, _path9, _g11, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBuildBetterCode(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 185,
    height: 249,
    viewBox: "0 0 185 249",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M98.7762 4.23139C97.8116 4.14065 96.8386 4.22924 95.9063 4.49268C94.5825 0.405872 90.2128 0.522804 90.2128 0.522804C90.2128 0.522804 85.843 0.411646 84.5207 4.49268C83.5874 4.22915 82.6135 4.14056 81.648 4.23139C79.4537 4.4537 78.6338 7.22539 80.3617 8.5968L85.2699 12.4945H95.1585L100.067 8.5968C101.792 7.22539 100.972 4.4537 98.7762 4.23139Z",
    fill: "#46A9D5",
    fillOpacity: 0.19
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_i_391_11)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M100.663 5.44827C100.324 6.13559 99.8003 6.71459 99.15 7.11995C98.5076 7.53426 97.6906 8.01065 96.8865 8.46105C96.4858 8.68875 96.0382 8.82136 95.5782 8.84864C95.1181 8.87592 94.6579 8.79715 94.2332 8.6184C91.8111 7.58715 89.0835 7.53541 86.624 8.47404C86.2005 8.641 85.7452 8.71206 85.2909 8.68211C84.8366 8.65216 84.3946 8.52194 83.9967 8.30081C83.2864 7.89805 82.5848 7.48518 82.019 7.11995C80.8872 6.38661 80.444 5.45838 80.2708 4.82031C79.9988 5.05722 79.7824 5.35115 79.637 5.68121C79.4915 6.01126 79.4206 6.36931 79.4293 6.72989C79.438 7.09046 79.526 7.44469 79.6872 7.76736C79.8484 8.09003 80.0787 8.37321 80.3617 8.59674L83.0915 10.7621L85.2685 12.4944H95.1571L100.065 8.59674C100.529 8.23307 100.845 7.71361 100.955 7.13466C101.065 6.55572 100.961 5.95656 100.663 5.44827Z",
    fill: "url(#paint0_linear_391_11)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_i_391_11)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M90.2128 10.6191C92.1681 10.6191 94.0433 11.3959 95.4259 12.7785C96.8085 14.1611 97.5852 16.0363 97.5852 17.9916V19.6762H82.8404V17.9916C82.8404 16.0363 83.6171 14.1611 84.9997 12.7785C86.3823 11.3959 88.2575 10.6191 90.2128 10.6191Z",
    fill: "url(#paint1_linear_391_11)"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_i_391_11)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M90.2128 53.0002C100.824 53.0002 109.426 44.3984 109.426 33.7875C109.426 23.1765 100.824 14.5747 90.2128 14.5747C79.6019 14.5747 71 23.1765 71 33.7875C71 44.3984 79.6019 53.0002 90.2128 53.0002Z",
    fill: "url(#paint2_linear_391_11)"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_i_391_11)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M90.2965 14.1328C92.0582 14.136 93.7776 13.5928 95.2177 12.5781C93.8577 11.3166 92.0706 10.6167 90.2157 10.6191C88.3952 10.6166 86.6387 11.2906 85.2872 12.5103C86.7437 13.5666 88.4973 14.1347 90.2965 14.1328Z",
    fill: "url(#paint3_linear_391_11)"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M90.2128 43.9397C90.4153 43.9397 90.6096 43.8592 90.7528 43.716C90.896 43.5728 90.9765 43.3786 90.9765 43.176V41.6559C92.0822 41.6153 93.129 41.1474 93.8969 40.3508C94.6648 39.5542 95.0938 38.4908 95.0938 37.3844C95.0938 36.2779 94.6648 35.2145 93.8969 34.4179C93.129 33.6213 92.0822 33.1534 90.9765 33.1128V30.3613C90.9765 30.1587 90.896 29.9645 90.7528 29.8213C90.6096 29.6781 90.4153 29.5976 90.2128 29.5976C90.0103 29.5976 89.816 29.6781 89.6728 29.8213C89.5296 29.9645 89.4491 30.1587 89.4491 30.3613V33.1041H88.6682C87.9392 33.1041 87.2401 32.8145 86.7246 32.2991C86.2091 31.7836 85.9196 31.0845 85.9196 30.3555C85.9196 29.6265 86.2091 28.9274 86.7246 28.412C87.2401 27.8965 87.9392 27.6069 88.6682 27.6069H92.6554C92.8579 27.6069 93.0521 27.5265 93.1953 27.3832C93.3386 27.24 93.419 27.0458 93.419 26.8433C93.419 26.6407 93.3386 26.4465 93.1953 26.3033C93.0521 26.1601 92.8579 26.0796 92.6554 26.0796H90.9765V24.5884C90.9765 24.3858 90.896 24.1916 90.7528 24.0484C90.6096 23.9052 90.4153 23.8247 90.2128 23.8247C90.0103 23.8247 89.816 23.9052 89.6728 24.0484C89.5296 24.1916 89.4491 24.3858 89.4491 24.5884V26.0854H88.6682C87.5341 26.0854 86.4465 26.5359 85.6446 27.3378C84.8427 28.1396 84.3922 29.2272 84.3922 30.3613C84.3922 31.4953 84.8427 32.5829 85.6446 33.3848C86.4465 34.1867 87.5341 34.6372 88.6682 34.6372H89.4434V40.1344H86.8334C86.7331 40.1344 86.6338 40.1541 86.5411 40.1925C86.4485 40.2309 86.3643 40.2871 86.2934 40.3581C86.2225 40.429 86.1662 40.5132 86.1278 40.6058C86.0894 40.6985 86.0697 40.7978 86.0697 40.8981C86.0697 40.9983 86.0894 41.0976 86.1278 41.1903C86.1662 41.2829 86.2225 41.3671 86.2934 41.438C86.3643 41.509 86.4485 41.5652 86.5411 41.6036C86.6338 41.642 86.7331 41.6617 86.8334 41.6617H89.4434V43.176C89.4434 43.2768 89.4633 43.3766 89.502 43.4696C89.5408 43.5626 89.5975 43.6471 89.6691 43.7181C89.7406 43.7891 89.8255 43.8452 89.9188 43.8832C90.0121 43.9213 90.112 43.9405 90.2128 43.9397ZM93.5706 37.3858C93.5716 38.0889 93.3025 38.7655 92.8189 39.276C92.3354 39.7864 91.6743 40.0916 90.9721 40.1286V34.643C91.6743 34.68 92.3354 34.9852 92.8189 35.4956C93.3025 36.0061 93.5716 36.6827 93.5706 37.3858Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M120.205 234.799L163.293 209.92C177.358 201.8 177.358 181.496 163.293 173.375L120.205 148.497C102.865 138.486 81.504 138.486 64.164 148.497L21.0765 173.375C7.01182 181.496 7.01182 201.8 21.0765 209.92L64.164 234.799C81.504 244.809 102.865 244.809 120.205 234.799Z",
    fill: "url(#paint4_radial_391_11)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M117.235 228.635L153.489 207.704C166.184 200.375 166.184 182.055 153.489 174.726L117.235 153.795C101.547 144.735 82.2187 144.735 66.5307 153.795L30.2766 174.726C17.5811 182.055 17.5811 200.375 30.2766 207.704L66.5307 228.635C82.2187 237.695 101.547 237.695 117.235 228.635Z",
    fill: "url(#paint5_radial_391_11)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M114.868 223.341L144.293 206.354C155.615 199.82 155.615 183.476 144.293 176.942L114.868 159.954C100.832 151.85 83.5373 151.85 69.4972 159.954L40.0726 176.942C28.7503 183.476 28.7503 199.82 40.0726 206.354L69.4972 223.341C83.5332 231.446 100.828 231.446 114.868 223.341Z",
    fill: "url(#paint6_radial_391_11)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M112.204 217.615L134.795 204.571C144.744 198.828 144.744 184.468 134.795 178.725L112.204 165.681C99.8155 158.528 84.558 158.528 72.17 165.681L49.5788 178.725C39.6298 184.468 39.6298 198.828 49.5788 204.571L72.17 217.615C84.558 224.768 99.8155 224.768 112.204 217.615Z",
    fill: "url(#paint7_radial_391_11)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M109.535 211.888L125.293 202.792C133.868 197.84 133.868 185.464 125.293 180.512L109.535 171.416C98.7989 165.218 85.5747 165.218 74.8387 171.416L59.081 180.512C50.5053 185.464 50.5053 197.84 59.081 202.792L74.8387 211.888C85.5747 218.087 98.7989 218.087 109.535 211.888Z",
    fill: "url(#paint8_radial_391_11)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M106.866 206.158L115.79 201.005C122.993 196.844 122.993 186.448 115.79 182.292L106.866 177.139C97.7823 171.896 86.5872 171.896 77.5032 177.139L68.579 182.292C61.3766 186.452 61.3766 196.848 68.579 201.005L77.5032 206.158C86.5872 211.401 97.7823 211.401 106.866 206.158Z",
    fill: "url(#paint9_radial_391_11)"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter4_i_391_11)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M92.1868 133.535L142.653 104.397L92.1868 75.2593L41.7205 104.397L92.1868 133.535Z",
    fill: "url(#paint10_linear_391_11)"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter5_i_391_11)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M92.1868 191.806L142.653 162.668V104.397L92.1868 133.535V191.806Z",
    fill: "url(#paint11_linear_391_11)"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter6_i_391_11)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M92.1868 191.806L41.7205 162.668V104.397L92.1868 133.535V191.806Z",
    fill: "url(#paint12_linear_391_11)"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter7_df_391_11)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M78.3762 127.697L50.0461 111.341C49.1606 110.828 48.8573 109.701 49.3697 108.816C49.8821 107.93 51.0094 107.627 51.8949 108.139L80.225 124.495C81.1105 125.008 81.4138 126.135 80.9014 127.021C80.389 127.906 79.2617 128.209 78.3762 127.697Z",
    fill: "#46A9D5",
    fillOpacity: 0.19,
    shapeRendering: "crispEdges"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter8_df_391_11)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M90.338 148.406V181.123C90.338 182.144 91.166 182.972 92.1868 182.972C93.2075 182.972 94.0355 182.144 94.0355 181.123V148.406C94.0355 147.386 93.2075 146.558 92.1868 146.558C91.166 146.558 90.338 147.386 90.338 148.406Z",
    fill: "#46A9D5",
    fillOpacity: 0.19,
    shapeRendering: "crispEdges"
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter9_df_391_11)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M105.993 127.697L134.323 111.341C135.209 110.828 135.512 109.701 135 108.816C134.487 107.93 133.36 107.627 132.475 108.139L104.144 124.495C103.259 125.008 102.956 126.135 103.468 127.021C103.98 127.906 105.108 128.209 105.993 127.697Z",
    fill: "#46A9D5",
    fillOpacity: 0.19,
    shapeRendering: "crispEdges"
  }))), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M94.7078 117.203L117.16 104.241C118.275 103.597 118.275 101.986 117.16 101.343L96.6632 89.5081C93.8962 87.9094 90.4814 87.9094 87.7144 89.5081L67.7017 101.064C66.3695 101.831 66.3695 103.753 67.7017 104.52L89.6698 117.203C91.2316 118.105 93.1542 118.105 94.7119 117.203H94.7078Z",
    fill: "#143247"
  })), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.17,
    d: "M51.2759 18.2419L63.3237 97.4237C63.4057 97.8869 63.5328 98.5879 63.6681 99.0347C64.4879 101.744 66.2219 104.126 68.706 105.585L88.0629 116.953C88.0998 116.973 88.6327 117.285 88.6696 117.301C90.5184 118.199 92.773 118.191 94.6177 117.277L116.209 104.593C117.938 103.609 119.025 102.08 119.472 100.232C119.488 100.162 119.718 98.7518 119.718 98.6576L130.675 18.2378C130.675 17.5573 117.237 17.0039 116.557 17.0039H65.4103C64.7298 17.0039 51.2759 17.5573 51.2759 18.2378V18.2419Z",
    fill: "url(#paint13_linear_391_11)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.33,
    d: "M53.8503 19.476L63.4877 97.3747C63.5533 97.7477 63.664 98.6004 63.7623 98.9611C64.5002 101.638 66.0825 104.044 68.5257 105.479L88.0588 116.953C88.1285 116.994 88.5999 117.269 88.6778 117.301C90.5552 118.191 92.8139 118.174 94.6832 117.248L115.975 104.737C117.758 103.749 118.914 102.396 119.369 100.589C119.406 100.445 119.607 99.2234 119.607 99.0308L128.371 19.4678C128.371 18.1027 116.959 17 115.594 17H66.6441C65.279 17 53.8544 18.1068 53.8544 19.4678L53.8503 19.476Z",
    fill: "url(#paint14_linear_391_11)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M56.4205 20.7097L63.6475 97.3253C63.6967 97.604 63.7869 98.6166 63.8566 98.8871C64.5125 101.531 65.9431 103.962 68.3412 105.372L88.0465 116.953C88.1531 117.014 88.5589 117.252 88.6737 117.301C90.5799 118.187 92.8426 118.162 94.7324 117.223L115.721 104.884C117.561 103.896 118.779 102.716 119.246 100.953C119.304 100.74 119.472 99.7029 119.472 99.4118L126.047 20.7097C126.047 18.6641 116.659 17.0039 114.614 17.0039H67.8657C65.8202 17.0039 56.4205 18.6641 56.4205 20.7097Z",
    fill: "url(#paint15_linear_391_11)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.67,
    d: "M58.9949 21.9435L63.8156 97.2761C63.8484 97.4606 63.914 98.633 63.955 98.8133C64.5289 101.433 65.812 103.884 68.1609 105.266L88.0383 116.953C88.1818 117.035 88.5261 117.236 88.6778 117.301C90.6126 118.178 92.8836 118.146 94.7939 117.195L115.479 105.028C117.373 104.036 118.66 103.031 119.135 101.31C119.213 101.027 119.353 100.17 119.353 99.7849L123.735 21.9435C123.735 19.2175 116.368 17.0039 113.642 17.0039H69.0955C66.3695 17.0039 58.9949 19.2134 58.9949 21.9435Z",
    fill: "url(#paint16_linear_391_11)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.83,
    d: "M61.5651 23.1818L63.9755 97.2313C63.9919 97.3256 64.0288 98.6537 64.0452 98.7439C64.5412 101.347 65.6685 103.807 67.9723 105.163L88.026 116.957C88.2022 117.064 88.4851 117.219 88.6737 117.306C90.6373 118.179 92.9123 118.134 94.8472 117.174L115.233 105.18C117.18 104.188 118.533 103.356 119.021 101.675C119.123 101.322 119.226 100.65 119.226 100.166L121.419 23.1818C121.419 19.7712 116.077 17.0083 112.667 17.0083H70.3171C66.9065 17.0083 61.5651 19.7712 61.5651 23.1818Z",
    fill: "url(#paint17_linear_391_11)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.8484 24.4157V98.666C63.8484 101.29 65.2381 103.72 67.5009 105.053L87.7268 116.953C87.9399 117.08 88.1572 117.199 88.3868 117.297C90.379 118.162 92.6582 118.113 94.6177 117.142L114.7 105.319C117.221 104.069 118.816 103.356 118.816 100.539V24.4157C118.816 20.3246 115.499 17.0083 111.408 17.0083H71.26C67.1689 17.0083 63.8525 20.3246 63.8525 24.4157H63.8484Z",
    fill: "url(#paint18_linear_391_11)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_391_11",
    x: 79.4286,
    y: 4.82031,
    width: 21.5691,
    height: 10.9273,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3.25299
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4.06624
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0313726 0 0 0 0 0.117647 0 0 0 0 0.290196 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_391_11"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_i_391_11",
    x: 82.8404,
    y: 10.6191,
    width: 14.7448,
    height: 12.3101,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3.25299
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4.06624
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0313726 0 0 0 0 0.117647 0 0 0 0 0.290196 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_391_11"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_i_391_11",
    x: 71,
    y: 14.5747,
    width: 38.4255,
    height: 41.6783,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3.25299
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4.06624
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0313726 0 0 0 0 0.117647 0 0 0 0 0.290196 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_391_11"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_i_391_11",
    x: 85.2872,
    y: 10.6191,
    width: 9.93045,
    height: 6.76666,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3.25299
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4.06624
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0313726 0 0 0 0 0.117647 0 0 0 0 0.290196 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_391_11"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_i_391_11",
    x: 41.7205,
    y: 75.2593,
    width: 100.933,
    height: 62.2754,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0313726 0 0 0 0 0.117647 0 0 0 0 0.290196 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_391_11"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter5_i_391_11",
    x: 92.1868,
    y: 104.397,
    width: 50.4663,
    height: 91.4092,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0313726 0 0 0 0 0.117647 0 0 0 0 0.290196 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_391_11"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter6_i_391_11",
    x: 41.7205,
    y: 104.397,
    width: 50.4663,
    height: 91.4092,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0313726 0 0 0 0 0.117647 0 0 0 0 0.290196 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_391_11"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter7_df_391_11",
    x: 44.1205,
    y: 102.89,
    width: 42.03,
    height: 33.0562,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_391_11"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_391_11",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5,
    result: "effect2_foregroundBlur_391_11"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter8_df_391_11",
    x: 85.338,
    y: 141.558,
    width: 13.6976,
    height: 49.4141,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_391_11"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_391_11",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5,
    result: "effect2_foregroundBlur_391_11"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter9_df_391_11",
    x: 98.2189,
    y: 102.89,
    width: 42.03,
    height: 33.0562,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_391_11"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_391_11",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5,
    result: "effect2_foregroundBlur_391_11"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_391_11",
    x1: 101.627,
    y1: 10.2249,
    x2: 99.0185,
    y2: 1.73664,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#46A9D5",
    stopOpacity: 0.19
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#46A9D5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_391_11",
    x1: 98.0152,
    y1: 16.9977,
    x2: 93.4764,
    y2: 8.44166,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#46A9D5",
    stopOpacity: 0.19
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#46A9D5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_391_11",
    x1: 110.546,
    y1: 41.6364,
    x2: 87.5365,
    y2: 14.9929,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#46A9D5",
    stopOpacity: 0.19
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#46A9D5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_391_11",
    x1: 95.5073,
    y1: 13.0937,
    x2: 94.3185,
    y2: 9.20355,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#46A9D5",
    stopOpacity: 0.19
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#46A9D5"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint4_radial_391_11",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(99.5007 193.401) rotate(-166.533) scale(81.3394 39.8701)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#46A9D5",
    stopOpacity: 0.19
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#46A9D5"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint5_radial_391_11",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(98.2554 192.745) rotate(-166.508) scale(70.859 34.7946)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#46A9D5",
    stopOpacity: 0.19
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#46A9D5"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint6_radial_391_11",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(97.6123 192.955) rotate(-166.473) scale(60.3816 29.72)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#46A9D5",
    stopOpacity: 0.19
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#46A9D5"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint7_radial_391_11",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(96.6727 192.732) rotate(-166.421) scale(49.8987 24.6475)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#46A9D5",
    stopOpacity: 0.19
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#46A9D5"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint8_radial_391_11",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(95.7292 192.514) rotate(-166.345) scale(39.4152 19.5695)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#46A9D5",
    stopOpacity: 0.19
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#46A9D5"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint9_radial_391_11",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(94.7837 192.286) rotate(-166.213) scale(28.9341 14.4944)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#46A9D5",
    stopOpacity: 0.19
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#46A9D5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_391_11",
    x1: 145.596,
    y1: 116.301,
    x2: 117.426,
    y2: 59.8036,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#46A9D5",
    stopOpacity: 0.19
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#46A9D5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_391_11",
    x1: 144.125,
    y1: 165.956,
    x2: 95.2366,
    y2: 133.272,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#46A9D5",
    stopOpacity: 0.19
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#46A9D5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_391_11",
    x1: 93.6584,
    y1: 165.956,
    x2: 44.7704,
    y2: 133.272,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#46A9D5",
    stopOpacity: 0.19
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#46A9D5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_391_11",
    x1: 90.9754,
    y1: 17.0039,
    x2: 90.9754,
    y2: 117.968,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#46A9D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#46A9D5",
    stopOpacity: 0.19
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_391_11",
    x1: 91.1107,
    y1: 17,
    x2: 91.1107,
    y2: 117.956,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#46A9D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#46A9D5",
    stopOpacity: 0.19
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_391_11",
    x1: 91.2337,
    y1: 17.0039,
    x2: 91.2337,
    y2: 117.947,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#46A9D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#46A9D5",
    stopOpacity: 0.19
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_391_11",
    x1: 91.3649,
    y1: 17.0039,
    x2: 91.3649,
    y2: 117.934,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#46A9D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#46A9D5",
    stopOpacity: 0.19
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_391_11",
    x1: 91.4919,
    y1: 17.0083,
    x2: 91.4919,
    y2: 117.929,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#46A9D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#46A9D5",
    stopOpacity: 0.19
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_391_11",
    x1: 91.3321,
    y1: 17.0083,
    x2: 91.3321,
    y2: 117.91,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#46A9D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#46A9D5",
    stopOpacity: 0.19
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBuildBetterCode);
export default __webpack_public_path__ + "static/media/build-better-code.0fa3b2c726321f41017fd2e7f448d0cc.svg";
export { ForwardRef as ReactComponent };